/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, quota: NonNullable<unknown> }} Calendar_Quota_Gauge_LabelInputs */

const fr_calendar_quota_gauge_label = /** @type {(inputs: Calendar_Quota_Gauge_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} sur ${i?.quota} utilisées`)
};

/**

* @param {Calendar_Quota_Gauge_LabelInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const calendar_quota_gauge_label = /** @type {((inputs: Calendar_Quota_Gauge_LabelInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Quota_Gauge_LabelInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_calendar_quota_gauge_label(inputs)
});